import { request, downloadRequest } from '@/utils/request'

/** 调度端 Tab → 接口 tab（0全部 1待接单 2待派单 3进行中 4已完成 5已拒绝 6已取消） */
export const DISPATCH_TAB_TO_API = {
  all: 0,
  pending: 1,
  dispatch: 2,
  in_progress: 3,
  completed: 4,
  rejected: 5,
  cancelled: 6,
}

/** 订单监控子 Tab → monitorTab（配合 tab=3）：1出发中 2装车中 3运输中；
 * 途中重量「全部」= 进行中(tab=3) + 已完成(tab=4) 合并；「已完成」单独走 tab=4 */
export const MONITOR_TAB_TO_API = {
  all: 0,
  departing: 1,
  loading: 2,
  transit: 3,
  completed: null,
}

/** dispatchAcceptStatus：0 待受理 1 已受理 2 已拒绝 */
export const DISPATCH_ACCEPT_STATUS = {
  NONE: 0,
  ACCEPTED: 1,
  REJECTED: 2
}

export function getDispatchWasteOrderPage(params) {
  return request({
    url: '/member/dispatch/waste-order/page',
    method: 'GET',
    data: params
  })
}

export function exportDispatchWasteOrder(params) {
  return downloadRequest({
    url: '/member/dispatch/waste-order/export-excel',
    data: params
  })
}

export function getDispatchWasteOrder(id) {
  return request({
    url: '/member/dispatch/waste-order/get',
    method: 'GET',
    data: { id }
  })
}

export function handleDispatchWasteOrder(data) {
  return request({
    url: '/member/dispatch/waste-order/handle',
    method: 'POST',
    data
  })
}

export function assignDispatchWasteOrder(data) {
  return request({
    url: '/member/dispatch/waste-order/assign-drivers',
    method: 'POST',
    data
  })
}

export function updateDispatchWasteOrderAppointment(data) {
  return request({
    url: '/member/dispatch/waste-order/update-appointment',
    method: 'POST',
    data
  })
}

export function uploadDispatchTransportPermit(data) {
  return request({
    url: '/member/dispatch/waste-order/upload-transport-permit',
    method: 'POST',
    data
  })
}

export function getDispatchDriverRejectPendingPage(params) {
  return request({
    url: '/member/dispatch/waste-order/driver-reject-pending/page',
    method: 'GET',
    data: params
  })
}

export function getDispatchDriverRejectAuditPage(params) {
  return request({
    url: '/member/dispatch/waste-order/driver-reject-audit/page',
    method: 'GET',
    data: params
  })
}

export function auditDispatchDriverReject(data) {
  return request({
    url: '/member/dispatch/waste-order/driver-reject-audit',
    method: 'POST',
    data
  })
}
